export default function(formData) {
  let ret = {};

  let keys = formData.keys();

  //ie11 hack
  if (!formData.keys()[Symbol.iterator]() === formData.keys()) {
    keys = [...formData.keys()];
  };

  for (var key of keys) {
    ret[key] = formData.get(key);
  }

  return ret;
};
